import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
interface StickyMobileCTAProps {
  isVisible: boolean;
}
export function StickyMobileCTA({
  isVisible
}: StickyMobileCTAProps) {
  return <AnimatePresence data-id="element-208">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden" data-id="element-209">
          <CTAButton fullWidth data-id="element-210">QUIERO EL PLAN ($19)</CTAButton>
        </motion.div>}
    </AnimatePresence>;
}